import { post } from "..";
import { CompanyServiceMatchType, CompanyType } from "../../types";

const path = "/api";

export const apiGenerateTokenForUsersApi = async (
  companyId: string
): Promise<{
  token: string;
  error: string | null;
}> => post(`${path}/generateToken`, { companyId });

export const apiSaveLinkOrgService = async (
  companyId: string,
  serviceId: string,
  serviceName: string
): Promise<{
  result: CompanyServiceMatchType;
  error: string | null;
}> =>
  post(`${path}/saveLinkOrgServiceApi`, { companyId, serviceId, serviceName });

export const apiOrganizationServiceList = async (): Promise<{
  result: CompanyServiceMatchType[];
  error: string | null;
}> => post(`${path}/reportOrganizationServiceList`);

export const apiCompaniesList = async (): Promise<{
  result: CompanyType[];
  error: string | null;
}> => post(`${path}/reportOrganizationList`);

export const apiAddNewCompany = async (
  companyName: string,
  login: string,
  inn: string
): Promise<{
  result: any;
  error: string | null;
}> => post(`${path}/addOrganizationApi`, { companyName, login, inn });

export const apiEditCompany = async (
  companyName: string,
  login: string,
  inn: string,
  innNew?: string
): Promise<{
  result: CompanyType;
  error: string | null;
}> => post(`${path}/updateOrganization`, { companyName, login, inn, innNew });

export const apiEditLinkOrgService = async (
  serviceId: string,
  serviceName: string,
  inn: string,
  newServiceId?: string
): Promise<{
  result: any;
  error: string | null;
}> =>
  post(`${path}/updateLinkOrgService`, {
    serviceName,
    serviceId,
    inn,
    newServiceId,
  });

export const apiDeleteLinkOrgService = async (serviceId: string) =>
  post(`${path}/deleteLinkOrgService`, {
    id: serviceId,
  });

export const apiDeleteOrganization = async (inn: string) =>
  post(`${path}/deleteOrganization`, {
    id: inn,
  });

export const apiGetReports = async (
  methodName: string,
  companyId: string | null = null,
  serviceId: string | null = null,
  dateBeginFiltered: string | null = null,
  dateEndFiltered: string | null = null
) =>
  post(`${path}/${methodName}`, {
    companyId,
    serviceId,
    dateBeginFiltered,
    dateEndFiltered,
  });

export const apiExcelReport = async (reportName: string) =>
  post(`${path}/excel${reportName}`, {}, { responseType: "blob" }, true, true);
